import './Footer.scss'
import { FooterTop } from './FooterTop'
import { FooterBottom } from './FooterBottom'
import { FooterMidden } from './FooterMidden'

function Footer () {
  return (
    <footer className='footer'>
      <FooterTop />
      <FooterMidden />
      <FooterBottom />
    </footer>
  )
}

export default Footer
